// extracted by mini-css-extract-plugin
export var deliveryRow = "_nd-a";
export var fixedHeight = "_nd-4";
export var freightLogo = "_nd-9";
export var fullWidth = "_nd-3";
export var priceColumn = "_nd-5";
export var radioSelected = "_nd-7";
export var radioUnselected = "_nd-6";
export var selectedOption = "_nd-2";
export var selectedOptionContainer = "_nd-1";
export var selection = "_nd-0";
export var tallSkeletonText = "_nd-8";